// extracted by mini-css-extract-plugin
export default {"form":"Login_form__KZ0VK","title":"Login_title__24Tgb"};